import CrumbLink from './CrumbLink';

export default function Crumb({ currentPath, item }) {
  if (currentPath === item.url || !item.url) {
    return <strong>{item.name}</strong>;
  }

  return <CrumbLink href={item.url}>{item.name}</CrumbLink>;
}
